import { render, staticRenderFns } from "./graficas.vue?vue&type=template&id=1979f103&scoped=true"
import script from "./graficas.vue?vue&type=script&lang=js"
export * from "./graficas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1979f103",
  null
  
)

export default component.exports